export default "__VITE_ASSET__BqOhF$2X__"